// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/font/iconfont.css';
import VueI18n from 'vue-i18n'
import VueClipboard from 'vue-clipboard2'
import Bridge from '../config/bridge.js'
Vue.prototype.$bridge = Bridge
Vue.use(VueClipboard);
Vue.use(VueI18n)
Vue.config.productionTip = false
const i18n = new VueI18n({
  locale: 'zh',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'kn': require('./common/lang/kn.js'),   // 韩文语言包
    'en': require('./common/lang/en'),    // 英文语言包
    'ri': require('./common/lang/ri'),    // 日文语言包
    'zhf': require('./common/lang/zhf'),  // 繁体中文语言包
    'zh': require('./common/lang/zh')  // 中文语言包
  }
})
router.beforeEach((to, from, next) => {
  // BPmarkets - 在初始化组件数据（）之前，从查询中设置i18n区域设置
  if (to.query.language) {
    i18n.locale = to.query.language;
  }
  window.document.title = to.meta.title == undefined?'':to.meta.title
  if (to.meta.requireAuth) {
    sessionStorage.setItem('titleName', window.document.title)
  }
  next();
})

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js